// 🌦️ Avisos de clima por WhatsApp / mail. Es la misma pantalla de Alertas de la obra (mismos destinatarios,
// misma colección alertConfigs) en modo clima, con una vista previa que recorre el pronóstico real de la obra.
// Se usa en Obra › Clima › Alertas y en Inteligencia › Alertas › Clima. No manda nada: el envío es del Editor.
import React, { useEffect, useState } from 'react';
import AlertasObra, { AVISOS_CLIMA } from '../../alertas/AlertasObra';
import R from './reglasClima';
import { pronostico } from './meteo';
import { leerConfig } from './configClima';
import { resolveLocation } from '../../IADashboard/weather';

/** Recorre los próximos 7 días hora por hora y cuenta qué avisaría cada uno (con la franja 8-20 h). */
export async function probarAvisosClima(loc, U, obra) {
  const pron = R.indexar(await pronostico(loc));
  const C = (obra.alertas && obra.alertas.clima) || {};
  const ahora = Date.now();
  const primero = {};
  const veces = {};
  for (let k = 0; k < 7 * 24; k++) {
    const t = ahora + k * 3600e3;
    R.avisosClima(pron, C, U, t).forEach((a) => {
      if (a.tipo === 'lluvia_ahora' && k > 0) return; // la lluvia medida es solo de este momento
      if (!primero[a.tipo]) primero[a.tipo] = { ...a, t };
      veces[a.tipo] = veces[a.tipo] || new Set();
      veces[a.tipo].add(a.clave);
    });
  }
  const cuando = (t) => {
    const l = R.localDe(t, pron.offset);
    const f = l.slice(0, 10), hoy = R.localDe(ahora, pron.offset).slice(0, 10);
    return `${f === hoy ? 'Hoy' : f === R.addDias(hoy, 1) ? 'Mañana' : R.fechaCorta(f)} a las ${Number(l.slice(11, 13))} h`;
  };
  const resultados = AVISOS_CLIMA.map((d) => {
    const on = C[d.key] && C[d.key].activo;
    if (!on) return { key: d.key, titulo: `${d.emoji} ${d.titulo}`, estado: 'apagada', texto: 'Apagado.' };
    if (d.key === 'camara_lluvia') return { key: d.key, titulo: `${d.emoji} ${d.titulo}`, estado: 'sin_datos', texto: 'Se revisa con la última foto de la cámara solo cuando el servicio meteorológico marca lluvia.' };
    const p = primero[d.key];
    if (!p) return { key: d.key, titulo: `${d.emoji} ${d.titulo}`, estado: 'ok', texto: d.key === 'lluvia_ahora' ? 'Se avisa en el momento en que empieza a llover en la obra.' : 'Con el pronóstico de hoy, en los próximos 7 días no habría aviso.' };
    const n = veces[d.key].size;
    return { key: d.key, titulo: `${d.emoji} ${d.titulo}`, estado: 'avisaria', texto: `${cuando(p.t)}: «${p.texto}»${n > 1 ? ` (${n} avisos en la semana)` : ''}` };
  });
  return {
    titulo: 'Vista previa con el pronóstico',
    subtitulo: 'Orientativa: no se envía nada. Recorre el pronóstico de los próximos 7 días con lo que elegiste en esta pantalla, aunque todavía no lo hayas guardado.',
    pie: 'Cada aviso sale una sola vez por día (o por tanda de lluvia). Salen de 8 a 20 h, salvo la tormenta eléctrica, que es urgente.',
    resultados,
  };
}

export default function AlertasClima({ feedID, telefonoSugerido, loc: locProp, U: UProp, cam, nota }) {
  const [loc, setLoc] = useState(locProp);
  const [U, setU] = useState(UProp);
  useEffect(() => { if (locProp) setLoc(locProp); }, [locProp]);
  useEffect(() => { if (UProp) setU(UProp); }, [UProp]);
  useEffect(() => {
    let vivo = true;
    if (!locProp) resolveLocation({ feedId: feedID, cam }).then((l) => vivo && setLoc(l)).catch(() => vivo && setLoc(null));
    if (!UProp) leerConfig(feedID).then((c) => vivo && setU(c.umbrales)).catch(() => vivo && setU(R.UMBRALES_DEFAULT));
    return () => { vivo = false; };
  }, [feedID, cam]); // eslint-disable-line react-hooks/exhaustive-deps

  const probar = async (obra) => {
    if (!loc) throw new Error('Primero ubicá la obra en el mapa (Obra › Clima)');
    return probarAvisosClima(loc, U || R.UMBRALES_DEFAULT, obra);
  };
  return (
    <AlertasObra feedID={feedID} telefonoSugerido={telefonoSugerido} modo="clima" probar={probar}
      notaClima={nota || <p className="mt-2 px-1 text-xs text-gray-500">Los avisos usan los criterios de día apto de la obra (lluvia, viento y temperatura) que se ajustan en Obra › Clima. Nunca se le pide nada a la cámara: los datos son del servicio meteorológico.</p>} />
  );
}
